import { notification } from 'antd';
import { FLAVOUR } from '../constants';
import { GO_TO_LOGIN, GO_TO_LOGOUT, INIT } from '../routes/paths';
import { track } from '../tracking';
import {
    AUTH_BASE_URL,
    AUTHGO_BASE_URL,
    DOCS_APP_BE_URL,
    MEDICAL_DB_BASE_URL,
    MEDICAL_RECORDS_BE_URL,
    TOKEN_REFRESH,
    TOKEN_REFRESH_V2,
    VERIFY_MOBILE_NUMBER,
} from './constants';
import { getCurrentMActiveId, getDocIdForMdb } from './mactiveid';
import { clearLocalStorage } from '../store/localstorage';

let accountDiffAlertTriggered = false;

const fetchWithRefresh = async (
    u: RequestInfo,
    options?: RequestInit,
    avoidAddioQParams?: boolean,
) => {
    try {
        const res = await fetchWithRefreshInternal(u, options, avoidAddioQParams);
        return res;
    } catch (error) {
        // track('ERROR', {
        //     on: 'fetchWithRefresh',
        //     what: u.toString(),
        //     error: (error as Error).message,
        // });
        try {
            const res = await fetchWithRefreshInternal(u, options, avoidAddioQParams);
            track('ERROR_SUCCESS', {
                on: 'fetchWithRefreshSecondTry',
                what: u.toString(),
            });
            return res;
        } catch (e) {
            // track('ERROR', {
            //     on: 'fetchWithRefreshSecondTry',
            //     what: u.toString(),
            //     error: (e as Error).message,
            // });
            throw e;
        }
    }
};

export const fetchWithRefreshWithoutRetry = async (
    u: RequestInfo,
    options?: RequestInit,
    avoidAddioQParams?: boolean,
) => {
    try {
        const res = await fetchWithRefreshInternal(u, options, avoidAddioQParams);
        return res;
    } catch (error) {
        // track('ERROR', {
        //     on: 'fetchWithRefresh',
        //     what: u.toString(),
        //     error: (error as Error).message,
        // });
        throw error;
    }
};

export const apiRefreshResponse = async () => {
    return await fetch(TOKEN_REFRESH_V2, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        body: JSON.stringify({}),
        headers: {
            'client-id': 'doc-web',
            'content-type': 'application/json',
        },
    });
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.refreshAuth = apiRefreshResponse;

const fetchWithRefreshInternal = async (
    u: RequestInfo,
    options?: RequestInit,
    avoidAddioQParams?: boolean,
) => {
    let url = u;
    if (typeof u === 'string' && !avoidAddioQParams) {
        const fl = new URLSearchParams({ flavour: FLAVOUR });

        if (u.indexOf('?') > -1) {
            url = `${url}&${fl}`;
        } else {
            url = `${url}?${fl}`;
        }
    }

    const headers = options?.headers ? new Headers(options.headers) : new Headers();

    // api manager
    if (url.toString().startsWith(DOCS_APP_BE_URL)) {
        headers.set('activeid', localStorage.getItem('activeId') || '');
        const mActiveId = getCurrentMActiveId();
        if (mActiveId) {
            headers.set('mactiveid', mActiveId);
        }
        try {
            headers.set('Time-Zone', Intl.DateTimeFormat().resolvedOptions().timeZone);
        } catch (e) {
            console.error('Error setting timezone to the API', e);
        }
    } else if (url.toString().startsWith(MEDICAL_RECORDS_BE_URL)) {
        headers.set('Client-id', 'doc-web');
        const parsedUrl = new URL(url.toString());
        parsedUrl.searchParams.set('archived', 'true');
        url = parsedUrl.toString();
    } else if (url.toString().startsWith(MEDICAL_DB_BASE_URL)) {
        // get query params from url
        const urlParams = new URLSearchParams(url.toString().split('?')[1]);
        // add docid to query params
        const docid = getDocIdForMdb();
        if (docid) {
            urlParams.set('docid', docid);
        }
        // add query params back to url
        url = `${url.toString().split('?')[0]}?${urlParams.toString()}`;
    } else if (
        url.toString().startsWith(AUTH_BASE_URL) ||
        url.toString().startsWith(AUTHGO_BASE_URL)
    ) {
        headers.set('Client-id', 'doc-web');
    }

    const op = { ...options, headers };
    if (new URL(url.toString()).host.endsWith('eka.care')) {
        op.credentials = 'include';
        op.mode = 'cors';
    }
    const res = await fetch(url, op);

    if (res.status === 401) {
        const refreshApi = await apiRefreshResponse();

        if (!refreshApi.ok) {
            track('ERROR', { on: TOKEN_REFRESH, error: refreshApi.status.toString() });
        }

        if (refreshApi.status === 200) {
            const res = await fetch(url, {
                ...options,
                mode: 'cors',
                credentials: 'include',
                headers,
            });

            if (!res.ok) {
                track('ERROR', { on: url.toString(), error: res.status.toString() });
            }

            if (res.status === 401) {
                logout();
            }

            track('ACTIVE_PULSE');
            return res;
        } else {
            logout();
        }
    }

    if (!res.ok) {
        let payload = undefined;
        if (url.toString() === VERIFY_MOBILE_NUMBER) {
            payload = options?.body ? JSON.stringify(options.body) : undefined;
        }
        track('ERROR', { on: url.toString(), error: res.status.toString(), payload });
    }

    const cn = Object.fromEntries(res.headers)['communication-notif'];

    if (cn?.length) {
        notification.error({
            message: cn,
            duration: 5,
        });
    }
    // api manager
    if (url.toString().startsWith(DOCS_APP_BE_URL)) {
        if (res.status === 403) {
            const response = await res.json();
            if (response.code === 'DIFF') {
                if (accountDiffAlertTriggered) {
                    return res;
                }

                accountDiffAlertTriggered = true;

                // TODO
                // re-discuss
                track('ACCOUNT_DIFF');
                alert('Change in account detected. Confirm reload of application.');
                clearLocalStorage();
                window.location.replace(INIT);
                return res;
            } else {
                accountDiffAlertTriggered = false;
            }
        }
    }

    return res;
};

export default fetchWithRefresh;

function logout() {
    try {
        if (window.location.pathname !== GO_TO_LOGIN) {
            window.location.replace(GO_TO_LOGOUT);
        }
    } catch (e) {
        console.error(e);
    }
}
